// Traduction de l'état du formulaire vers les corps de requête API.
// Fonctions pures : aucune dépendance React ni réseau.

const numOrNull = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};
const numOrZero = (v) => numOrNull(v) ?? 0;
const textOrNull = (v) => (v && String(v).trim() ? String(v).trim() : null);

/** Champs communs à l'envoi : expéditeur, destinataire, trajet. */
const shipmentFields = (form) => ({
  sender_name: form.sender.name,
  sender_phone: form.sender.phone,
  sender_email: textOrNull(form.sender.email),
  recipient_name: form.recipient.name,
  recipient_phone: form.recipient.phone,
  recipient_email: textOrNull(form.recipient.email),
  destination_country: form.destination_country,
  destination_city: textOrNull(form.destination_city),
  transport_mode: form.transport_mode || null,
});

/** Un payload POST /api/packages par colis : prix et règlement propres à chacun. */
export function buildPackagePayloads(form, { merchandiseSupplement = null } = {}) {
  const isMaritime = form.transport_mode === 'maritime';
  const common = shipmentFields(form);

  return form.items.map((item, i) => ({
    ...common,
    description: item.description,
    weight: isMaritime ? 0 : numOrZero(item.weight),
    length_cm: isMaritime ? numOrNull(item.length_cm) : null,
    width_cm: isMaritime ? numOrNull(item.width_cm) : null,
    height_cm: isMaritime ? numOrNull(item.height_cm) : null,
    origin_country: form.origin_country,
    merchandise_category_id: form.merchandise_category_id || null,
    // Le supplément de catégorie est déjà inclus dans le prix proposé du premier
    // colis ; le répéter le compterait plusieurs fois dans les exports finance.
    merchandise_supplement: i === 0 ? (merchandiseSupplement ?? null) : null,
    price: numOrNull(item.price),
    payment_status: item.payment_status || 'unpaid',
    is_paid: item.payment_status === 'paid',
    payment_method: item.payment_method || null,
    advance_amount: item.payment_status === 'advance' ? numOrNull(item.advance_amount) : null,
  }));
}

/**
 * Corps de POST /api/qr-sessions/{token}/submit.
 * Le client déclare ce qu'il règle, jamais le prix : celui-ci vient de la grille
 * tarifaire de la route, appliquée par le partenaire à la validation.
 */
export function buildQrSubmitPayload(form) {
  const [first = {}] = form.items;

  return {
    ...shipmentFields(form),
    // Champs plats conservés pour les backends antérieurs au multi-colis.
    weight: numOrZero(first.weight),
    description: first.description || '',
    payment_status: first.payment_status || 'unpaid',
    is_paid: first.payment_status === 'paid',
    payment_method: first.payment_method || null,
    advance_amount: first.payment_status === 'advance' ? numOrNull(first.advance_amount) : null,

    packages: form.items.map((item) => ({
      description: item.description,
      weight: numOrZero(item.weight),
      length_cm: numOrNull(item.length_cm),
      width_cm: numOrNull(item.width_cm),
      height_cm: numOrNull(item.height_cm),
      merchandise_category_id: form.merchandise_category_id || null,
      payment_status: item.payment_status || 'unpaid',
      payment_method: item.payment_method || null,
      advance_amount: item.payment_status === 'advance' ? numOrNull(item.advance_amount) : null,
    })),
  };
}
